/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authOrgsUpdateRateLimit } from "../../funcs/authOrgsUpdateRateLimit.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateOrgRateLimitRequest$inboundSchema,
};

export const tool$authOrgsUpdateRateLimit: ToolDefinition<typeof args> = {
  name: "auth-orgs-update-rate-limit",
  description: `Set an org's rate limit (cluster-admin)`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authOrgsUpdateRateLimit(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
